module.exports = __webpack_public_path__ + "static/media/CCTP_- _Art_Teacher_s Guide_(v1).4eb7f7cd.pptx";